import { getDateLocaleCode } from './i18n';

export const formatCalendarShortWeekday = (locale, date) =>
  new Intl.DateTimeFormat(locale, { weekday: 'short' }).format(date);

export const formatCalendarWeekday = (locale, date) =>
  new Intl.DateTimeFormat(locale, { weekday: 'long' }).format(date);

export const calendarNavigationLabel = ({ date, locale }) => {
  const month = date.toLocaleDateString(locale, { month: 'long' });
  const year = date.getFullYear();
  return `${month}, ${year}`;
};

/** Shared react-calendar locale props — read at call time (not module load). */
export const getReactCalendarProps = () => ({
  locale: getDateLocaleCode(),
  formatShortWeekday: formatCalendarShortWeekday,
  formatWeekday: formatCalendarWeekday,
  navigationLabel: calendarNavigationLabel,
});
